import script from "./DealExportsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DealExportsPage.vue?vue&type=script&setup=true&lang=js"

import "./DealExportsPage.vue?vue&type=style&index=0&id=7cccd13a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cccd13a"]])

export default __exports__